module.exports = __webpack_public_path__ + "media/music/jazzy_bass_9-58e9d222.mp3";